module.exports = __webpack_public_path__ + "img/pingjia.c832e8de.png";